// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--2oztB"};